import { formatMessage } from '@bookingdei/i18n/interpolate';
import { useLanguage } from './language-context';
import { useSettings } from './settings-context';

// The search pill's and the ⌘K palette's placeholder (design bd-core.js `T.search`,
// "Search bookings, businesses or BD- code"): it names the registry's booking-code
// prefix (API-27 `booking_code_prefix`, INF-1 — never a literal); before the settings
// load it reads "booking code".
export function useSearchHint(): string {
  const { t, lang } = useLanguage();
  const prefix = useSettings().settings?.booking_code_prefix;
  return prefix ? formatMessage(lang, 'user.shell.search.placeholder_prefixed', { prefix }) : t('user.shell.search.placeholder');
}
